/**
 * 使用环境参数
 * @return {object} { isPreRender: boolean }
 */
export function useEnv() {
    return window.FEGORender.common.env;
}
